import data from './data'
import methods from './methods'
import props from './props'

export default {
  data,
  methods,
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/history/index/components/schedule/resources/index.js